// extracted by mini-css-extract-plugin
export default {"root":"textInput_root__iGTQ0","wrap_root":"textInput_wrap_root__C3aN8"};